import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { MyserviceService } from '../myservice.service';
import { DatePipe } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-handling-reports',
  templateUrl: './error-handling-reports.component.html',
  styleUrls: ['./error-handling-reports.component.css'],
    providers: [MessageService, DatePipe]
})
export class ErrorHandlingReportsComponent implements OnInit {
  alwaysShowCalendars: boolean;
  ranges: any = {
    'Today': [moment().startOf('day'), moment().endOf('day')],
    'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
    'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
    'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
    'Last Month': [
      moment().subtract(1, 'month').startOf('month').startOf('day'),
      moment().subtract(1, 'month').endOf('month').endOf('day')
    ]
  };
  isDateDisabled: boolean = false;
  selectedDate: any;

  reportsLookup: any[] = [
    
    {label: 'Select', key: ''},
    {label: 'US Banking Report', key: 'US Banking Report'}
  ];
  reportTypeControl: any
  loader: boolean;  
  invoiceHeaders = [
    { field: 'maerskBOL', header: 'Maersk BOL', width: '150px' },
    { field: 'carrier', header: 'Carrier', width: '120px' },
    { field: 'scac', header: 'SCAC', width: '100px' },
    { field: 'coreAdvance', header: 'CORE Advance', width: '130px' },
    { field: 'invoiceNumber', header: 'Invoice Number', width: '140px' },
    { field: 'invoiceDate', header: 'Invoice Date', width: '120px' },
    { field: 'invoiceAmount', header: 'Invoice Amount', width: '140px' },
    { field: 'currency', header: 'Currency', width: '100px' },
    { field: 'endAccounting', header: 'End Accounting', width: '140px' },
    { field: 'reProcessFlag', header: 'ReProcess Flag', width: '130px' },
    { field: 'usBankID', header: 'US Bank ID', width: '120px' },
    { field: 'errorReason', header: 'Error Reason', width: '150px' },
    { field: 'fileDateTime', header: 'File DateTime', width: '160px' },
    { field: 'ediControlNumber', header: 'EDI Control Number', width: '160px' }
  ];
  
  invoiceData = []; // Populate from API or mock data
  reprocessOptions = [
    { label: 'Ready For User', value: 0 },
    { label: 'Ready To Reprocess', value: 1 },
    { label: 'Ignore', value: 2 },
    { label: 'Processed', value: 3 }
  ];
  
  constructor(private service: MyserviceService, private datepipe: DatePipe,
          public localstorage: LocalStorageService, private router: Router) { }

  ngOnInit() {
    let fromDate = new Date();
    let toDate = new Date();
    this.selectedDate = {
      startDate: new Date(
          fromDate.getFullYear(),
          fromDate.getMonth(),
          fromDate.getDate(),
          0,
          0,
          0
      ),
      endDate: new Date(
          toDate.getFullYear(),
          toDate.getMonth(),
          toDate.getDate(),
          0,
          0,
          0
      ),
  };
    this.getErrorHandlingDetails();
  }

  getErrorHandlingDetails() {
    this.selectedDate.fromDate = this.datepipe.transform(
      this.selectedDate.startDate,
      "MM/dd/yyyy HH:mm"
  );
  this.selectedDate.toDate = this.datepipe.transform(
      this.selectedDate.endDate,
      "MM/dd/yyyy HH:mm"
  );
    const params = {
      fromDate: this.selectedDate.fromDate,
      toDate: this.selectedDate.toDate,
    }
    this.service.getErrorHandlingReports(params).subscribe((res: any) => {
      console.log(' ----- ',res);
      this.invoiceData = res;
    })
  }
    

  
  onInvoicePagination(event: any) {
    // Handle lazy loading logic
  }

  setToDefault() {
    let today = new Date(); // this.service.getDateByTZ();
    this.selectedDate = {
      startDate: new Date(
        today.getUTCFullYear() || new Date().getUTCFullYear(),
        today.getUTCMonth() || new Date().getUTCMonth(),
        today.getUTCDate() || new Date().getUTCDate(),
        0,
        0,
        0
      ),
      endDate: new Date(
        today.getUTCFullYear() || new Date().getUTCFullYear(),
        today.getUTCMonth() || new Date().getUTCMonth(),
        today.getUTCDate() || new Date().getUTCDate(),
        23,
        59,
        0
      ),
    };
    this.reportTypeControl = null;
  }

  submit() {
    this.getErrorHandlingDetails()
  }
  getLabels(value: number): string {
    const found = this.reprocessOptions.find(item => item.value === value);
    return found ? found.label : '';
  }
  // getLabels(value: number) {
  //   const match = this.reprocessOptions.find(item => item.value === value);
  //   console.log('getLabels called with', value, match);
  //   return match ? match.label : '';
  // }

  onCellSave(data: any, index: number) {
      console.log('Updated row:', data, index);
    if (index !== undefined && index !== null) {
      this.invoiceData[index] = { ...this.invoiceData[index], ...data };
      // Optional: Trigger change detection if necessary
    }
  }

  getRowData(rowData: any) {
    this.service.sendErrorHandlingInfo(rowData);
    this.router.navigate(['/mscvp/error-handling-details']);
  }
}
